/* eslint-disable no-console */
import React, { useEffect, useState } from 'react';
import { Tab, Title } from 'src/components';
import { DashboardLayout } from 'src/containers';
import useFetch from 'src/hooks/useFetch';
import { shallowEqual, useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/reducers';
import { fetchSetting } from 'src/redux/action/setting.action';
import Service from 'src/setup/network';
import Address from './Address';
import DeliveryZone from './DeliveryZone';
import SocailMedia from './SocailMedia';
import WorkingHours from './WorkingHours';
import { fetchDetails } from 'src/redux/action/details.action';
import OrderTypes from './OrderTypes';
import Loader from 'src/components/loader';
import TaxesTab from './Taxes';
import OnlineOrdering from './OnlineOrdering';
import PaymentMethod from './AddPayment/PaymentMethod';
import ImageSlider from './Image';
import About from './About';
import GoogleAnalytics from './GoogleAnalytics';

interface IProps {}

// const allowedOrderTypes = {
//   delivery: true,
//   dine_in: true,
//   takeway: true,
//   online_order: false,
// };

const Details = () => {
  const [hasFetched, setHasFetched] = useState(false);
  // const [activeTabIndex, setActiveIndex] = React.useState(0);
  const [activeTabIndex, setActiveIndex] = React.useState(
    Number(localStorage.getItem('activeTabIndex')) || 1
  );

  useEffect(() => {
    localStorage.setItem('activeTabIndex', activeTabIndex.toString());
  }, [activeTabIndex]);
  const dispatch = useDispatch();
  const tabData = [
    // {
    //   id: 0,
    //   label: 'Address & Contact',
    //   lock: false,
    // },
    {
      id: 1,
      label: 'About',
      lock: false,
    },
    {
      id: 2,
      label: 'Images',
      lock: false,
    },

    {
      id: 3,
      label: 'Working Hours',
      lock: false,
    },
    {
      id: 4,
      label: 'Online Ordering',
      lock: true,
    },

    {
      id: 5,
      label: 'Delivery Zone',
      lock: true,
    },
    {
      id: 6,
      label: 'Loyalty',
      lock: true,
    },
    {
      id: 7,
      label: 'Order Types',
      // lock: true,
    },

    {
      id: 8,
      label: 'Payment Method',
      lock: false,
    },
    {
      id: 9,
      label: 'Social Media',
      lock: false,
    },
    {
      id: 10,
      label: 'Extra Charges',
      lock: false,
    },
    {
      id: 11,
      label: 'Google Analytics',
      lock: false,
    },
  ];

  const { settingData } = useSelector(
    ({ settingData }: RootState) => settingData,
    shallowEqual
  );
  const { detailsData, loading, error } = useSelector(
    ({ detailsData }: RootState) => detailsData,
    shallowEqual
  );

  // const state: any = window.localStorage.getItem('details');
  // const DetailsData = JSON.parse(state);
  React.useEffect(() => {
    dispatch(fetchDetails() as any);
  }, [dispatch]);
  React.useEffect(() => {
    if (detailsData?.length > 0) return;
    dispatch(fetchSetting() as any);
  }, [dispatch]);

  return (
    <>
      {/* <Title text="" /> */}
      <div className="text-black rounded-xl border border-border-color-dark p-6  mb-20">
        {/* <div className="flex items-center space-x-3">
          <img
            src={settingData?.businessInfo?.logo}
            alt="business-logo"
            className="w-[60px] h-[60px] rounded-xl"
          />
          <p className="text-[black] font-semibold">
            {settingData?.businessInfo?.name}
          </p>
        </div> */}
        <div className="grid grid-cols-12 gap-9 text-black rounded-xl ">
          <div className="md:col-span-3 col-span-12 h-max sticky top-2">
            <Tab
              activeIndex={activeTabIndex}
              setActiveIndex={setActiveIndex}
              tabData={tabData}
            />
          </div>
          <div className="md:col-span-8 col-span-12">
            {activeTabIndex === 0 ? (
              <div className="rounded-xl border border-border-color-dark w-[388px] p-6 mb-10 ">
                {loading ? (
                  <Loader />
                ) : (
                  <Address address={detailsData} loading={loading} />
                )}
              </div>
            ) : activeTabIndex === 3 ? (
              <div className="rounded-xl border border-border-color-dark w-[388px] p-6 ">
                {loading ? (
                  <Loader />
                ) : (
                  <WorkingHours
                    workingHours={detailsData?.workingHours}
                    loading={loading}
                  />
                )}
              </div>
            ) : activeTabIndex === 4 ? (
              <div className="rounded-xl border border-border-color-dark w-[388px] p-6 ">
                {loading ? <Loader /> : <OnlineOrdering />}
              </div>
            ) : activeTabIndex === 5 ? (
              <div className="rounded-xl border border-border-color-dark w-[388px] p-6 ">
                {loading ? (
                  <Loader />
                ) : (
                  <DeliveryZone detailsData={detailsData} loading={loading} />
                )}
              </div>
            ) : activeTabIndex === 7 ? (
              <>
                {loading ? (
                  ''
                ) : (
                  <div className="rounded-xl border border-border-color-dark w-[518px] p-6 ">
                    <OrderTypes
                      allowedOrderTypes={detailsData?.allowedOrderTypes}
                      loading={loading}
                    />
                  </div>
                )}
              </>
            ) : activeTabIndex === 8 ? (
              <div className="rounded-xl border border-border-color-dark w-[690px] p-6 pr-0 pl-4  -ml-4 mb-5">
                {/* <OrderTypes
                    allowedOrderTypes={detailsData?.allowedOrderTypes}
                  /> */}
                <PaymentMethod loading={loading} />
              </div>
            ) : activeTabIndex === 10 ? (
              <div className=" w-[518px] p-6 ">
                {loading ? <Loader /> : <TaxesTab />}
              </div>
            ) : activeTabIndex === 9 ? (
              <div className="rounded-xl border border-border-color-dark w-[388px] p-6 ">
                <SocailMedia
                  socialLinks={detailsData?.socialLinks}
                  loading={loading}
                />
              </div>
            ) : activeTabIndex === 11 ? (
              <div className="rounded-xl border border-border-color-dark w-[388px] p-6 ">
                <GoogleAnalytics gtag={detailsData?.gTag} loading={loading} />
              </div>
            ) : activeTabIndex === 2 ? (
              <div className="rounded-xl border border-border-color-dark w-[800px] p-6">
                <ImageSlider />
              </div>
            ) : activeTabIndex === 1 ? (
              <div className=" ">
                <About detailData={detailsData} loading={loading} />
              </div>
            ) : null}
            {/* </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default React.memo(Details);
